import FlowStartingConfigContent from './FlowConditionsConfigContent'

export default FlowStartingConfigContent
